import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClockInPending(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 101 68" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle
        cx="50.4999"
        cy="34.0009"
        r="25.5682"
        stroke="url(#paint0_linear_3299_54225)"
        strokeWidth="5.68182"
      />
      <path
        d="M50.5 18L50.5 33.9091L59.0227 24.8182"
        stroke="#0C1C43"
        strokeWidth="0.568182"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3299_54225"
          x1="50.4999"
          y1="5.59179"
          x2="50.4999"
          y2="62.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#98CCFB" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgClockInPending);
export default ForwardRef;
